module.exports = "https://static.zego.com/_next/static/images/HaulageFleet-61dd3191c4c2625dcaaf06ae3a49ce1e.svg";